module.exports = __webpack_public_path__ + "img/lagranja.078bf97c.png";